import type { FaireProductEntity } from "../../entity_types/product";

export const p_4hsuyzyx5f: FaireProductEntity = {
  token: "p_4hsuyzyx5f",
  type: "product",
  name: "Cream Mary Jewelry, Pendant Necklace, Gold Religious Jewelry",
  brandToken: "b_753b7wy8",
  brandName: "Laalee Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/47b97ef7e50891e2de92b56384730be0214788515438dd87c57a1710cefadc96.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1200f74c8048514fdba4631409737553acbb6b1c2ba5471b29e3b4776980af04.jpeg",
    "https://cdn.faire.com/fastly/1f4965cfd66dd3daad4fddf9463aaf270e708152dc563f9b7fbe61dcaf4def14.jpeg",
    "https://cdn.faire.com/fastly/231544a1c61bb11ed3346c6d0b648b909f31679c8094b194741088661ed5a135.jpeg",
  ],
  priceDollars: 29.1,
  description:
    "Stunning cream Virgin Mary pendant medal necklace on 14k gold filled chain with 14k gold filled jumprings/clasp. Measures approx 20X30mm. ",
  tags: [],
  msrpDollars: 58.2,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:54.721Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
